import { render, staticRenderFns } from "./EbookListDetails.vue?vue&type=template&id=57665792&"
import script from "./EbookListDetails.vue?vue&type=script&lang=js&"
export * from "./EbookListDetails.vue?vue&type=script&lang=js&"
import style0 from "./EbookListDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports